<template>
  <div>
    <div class="jumbotron">
      <div class="mask tra"></div>
      <b-row class="pt-5 text-left text-white" style="margin: auto;">
        <b-col cols="4" md="2" class="text-right">
          <b-img src="/iconss/traduttori.png" class="rounded-pill bg-white text-center p-2"></b-img>
        </b-col>
        <b-col cols="4" class="">
          <h1>Traduttori</h1>
          <p>Area riservata</p>
        </b-col>
        <!--b-col sm="4" class="text-right pr-4">
          {{ user.first_name }} {{ user.last_name }} <br />
          <span v-for="item in user.languages" :key="item.id" style="text-transform: uppercase">
            <span class="pl-2 pr-1">{{ item.flag }} {{ item.id }}</span>
            <b-icon-dot></b-icon-dot>
          </span>
        </b-col-->
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col cols="12" class="bg-white text-left my-3">
        <h2>Richieste in cerca di revisore</h2>
        <div>
          <b-table small :fields="colonne" :items="request" responsive="sm" ref="requestTable">
            <!-- A custom formatted column -->
            <template v-slot:cell(1)="data">
              <b-row>
                <b-col cols="auto">
                  <b-button
                    pill
                    @click.prevent="download(`${data.item.id}/original/${data.item.name}`)"
                    variant="outline-info"
                    class="btn-circle"
                    title="Scarica anteprima documento da tradurre"
                  >
                    <b-icon-file-earmark variant="outline-primary"></b-icon-file-earmark>
                  </b-button>
                  <span class="flag">
                    {{ data.item.src_language.flag }}
                  </span>
                </b-col>
                <b-col>
                  <a
                    :href="data.item.name"
                    title="Scarica anteprima documento da tradurre"
                    @click.prevent="download(`${data.item.id}/original/${data.item.name}`)"
                  >
                    {{ data.item.name }}
                    <span v-if="data.item.document_type">[{{ data.item.document_type }}]</span>
                  </a>
                  <div class="text-muted small">
                    <b>Richiesto da</b>&nbsp;
                    <b-avatar
                      size="1.5rem"
                      :text="`${data.item.requester.first_name.substr(0, 1)} ${data.item.requester.last_name.substr(0, 1)}`"
                    ></b-avatar>
                    <span v-if="data.item.requester">{{ data.item.requester.organization }}</span>
                    <br />
                    <a @click="showNote(data.item.note)" v-if="data.item.note" href="#">
                      Note del richiedente
                      <b-icon-eye></b-icon-eye>
                    </a>
                  </div>
                </b-col>
              </b-row>
            </template>

            <!-- A virtual composite column -->
            <template v-slot:cell(2)="data">
              <span class="flag">{{ data.item.dest_language.flag }}</span>
              {{ data.item.dest_language.description }}
              <b-icon-music-note
                v-if="data.item.request_audio"
                title="E' richiesta anche la lettura audio"
                v-b-tooltip.hover
              ></b-icon-music-note>
            </template>

            <!-- Optional default data cell scoped slot -->
            <template v-slot:cell(3)="data">
              <span v-if="data.item.due_date">
                {{ data.item.due_date | moment("DD/MM/YYYY") }}
              </span>
            </template>

            <template v-slot:cell(4)="data">
              <b-button
                :href="data.item.name"
                pill
                @click.prevent="download(`${data.item.id}/translated/${data.item.name}`)"
                variant="outline-secondary"
                v-if="isAutoTranslatable(data.item)"
                class="w-100"
                style="max-width: fit-content"
                :disabled="download_busy"
              >
                <!-- <b-spinner small type="grow" v-if="download_busy"></b-spinner>
                <b-iconstack>
                  <b-icon stacked icon="chat" variant="secondary"></b-icon>
                  <b-icon stacked icon="gear" variant="secondary" shift-v="-3" shift-h="2" scale="0.60"></b-icon>
                </b-iconstack>
                <small>Scarica Traduzione Automatica</small> -->
                <b-row align-v="center">
                  <b-col cols="1">
                    <b-iconstack>
                      <b-icon stacked icon="chat" variant="secondary"></b-icon>
                      <b-icon stacked icon="gear" variant="secondary" shift-v="-3" shift-h="2" scale="0.60"></b-icon>
                    </b-iconstack>
                  </b-col>
                  <b-col cols="9">
                    <small>Scarica Traduzione Automatica</small>
                  </b-col>
                </b-row>
              </b-button>
            </template>

            <template v-slot:cell(5)="data">
              <b-button variant="info" size="sm" v-b-modal.modal-takeCharge @click="sendDocId(data.item.id)" pill>
                <b>Prendi in carico</b>
              </b-button>
            </template>
          </b-table>

          <b-modal id="modal-takeCharge" title="Presa in carico" @ok="handleOk()">
            <p class="my-4">
              Facendo click su OK mi impegno a tradurre il documento allegato facendo il possibile per rispettare il
              tempo di consegna richiesto.
            </p>
          </b-modal>
        </div>
        <hr class="border border-info rounded" />
      </b-col>
    </b-row>
    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <!-- Richieste IN LAVORAZIONE -->
      <b-col lg="6" class="pr-4 text-black text-left">
        <b-row>
          <b-col><h3>Richieste in lavorazione</h3></b-col>
          <b-col>
              <b-dropdown id="dropdown-form" text="Ordina" variant="outline-secondary" ref="dropdown" class="m-2" size="sm">
              <b-dropdown-form>
                
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="src_lang_id">Lingua sorgente</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="dest_lang_id">Lingua di destinazione</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="name">Nome del documento originale</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="document_type">Tipo di documento</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="due_date">Data di scadenza</b-form-radio>
                </b-form-group>
                <b-dropdown-divider></b-dropdown-divider>
                <b-form-group v-slot="{ ariaDescribedby2 }">
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="ASC" active>Crescente</b-form-radio>
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="DESC">Decrescente</b-form-radio>
                </b-form-group>
                <b-button variant="primary" size="sm" @click="order('pending',true)">Cerca</b-button>
                <b-button variant="outline-danger" size="sm" @click="order('pending',false)">Cancella</b-button>
              </b-dropdown-form>
              </b-dropdown>
          </b-col>
        </b-row>

       <b-row>
          <b-col md="6" lg="12" v-for="item in pending" :key="item.id">
            <card-tra :item="item"></card-tra>
          </b-col>
        </b-row>
      </b-col>

      <!-- Richieste COMPLETATE -->
      <b-col lg="6" class="pr-4 text-black text-left">
        <b-row>
          <b-col>
            <h3>Richieste completate</h3>
          </b-col>
          <b-col>
            <b-dropdown id="dropdown-form" text="Ordina" variant="outline-secondary" ref="dropdown2" class="m-2" size="sm">
              <b-dropdown-form>
                
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="src_lang_id">Lingua sorgente</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="dest_lang_id">Lingua di destinazione</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="name">Nome del documento originale</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="document_type">Tipo di documento</b-form-radio>
                  <b-form-radio v-model="orderBy" :aria-describedby="ariaDescribedby" name="some-radios" value="due_date">Data di scadenza</b-form-radio>
                </b-form-group>
                <b-dropdown-divider></b-dropdown-divider>
                <b-form-group v-slot="{ ariaDescribedby2 }">
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="ASC" active>Crescente</b-form-radio>
                  <b-form-radio v-model="asc" :aria-describedby="ariaDescribedby2" name="some-radios2" value="DESC">Decrescente</b-form-radio>
                </b-form-group>
                <b-button variant="primary" size="sm" @click="order('completed',true)">Cerca</b-button>
                <b-button variant="outline-danger" size="sm" @click="order('completed',false)">Cancella</b-button>
              </b-dropdown-form>
              </b-dropdown>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" lg="12" v-for="item in completed" :key="item.id">
            <card-tra :item="item"></card-tra>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal id="modal-upload" title="Carica la revisione" @ok="handleUpload()">
      <b-overlay :show="loading" rounded="sm">
        <b-form-file
          v-model="file"
          :state="Boolean(file)"
          placeholder="Carica o trascina qui il file con la revisione..."
          drop-placeholder="Trascina qui il file con la revisione..."
        ></b-form-file>
      </b-overlay>
    </b-modal>

    <b-modal id="modal-audio" title="Registra la traduzione audio" @ok="handleAudioUpload">
      <b-row>
        <b-col cols="3">
          <VueRecordAudio mode="press" @result="onRecord" class="mx-auto" />
        </b-col>

        <b-col cols="9">
          Clicca sull’icona del microfono qui accanto avviare e arrestare la registrazione. Potrai poi ascoltarla usando
          il player che comparirà qui sotto. Per caricarla, clicca su “OK”, altrimenti clicca sul microfono e registra
          di nuovo.
        </b-col>
      </b-row>

      <b-row>
        <b-col offset="3">
          <audio controls="controls" :src="audioBlobUrl" v-if="audioBlob != null">
            Il tuo browser non supporta l'audio
          </audio>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import cardTra from "@/components/CardTra";
import authHeader from "@/services/auth-header";
import util from "@/mixing/util";
import UserService from "@/services/user.service";
import authFileHeader from "@/services/auth-header";

export default {
  components: { cardTra },
  mixins: [util],
  data() {
    return {
      colonne: [
        { key: "1", label: "Documento originale" },
        { key: "2", label: "Lingua richiesta" },
        { key: "3", label: "Data desiderata" },
        { key: "4", label: "Traduzione automatica" },
        { key: "5", label: "" },
      ],
      docId: null,
      pending: [],
      completed: [],
      request: [],
      show: true,
      userId: this.$route.params.userId,
      user: [],
      status: [],
      note: "",
      file: null,
      loading: false,
      audioBlob: null,
      orderBy: null,
      asc: 'ASC',
    };
  },
  mounted() {
    this.getPending();
    this.getCompleted();
    this.getRequest();

    UserService.getStatus().then((response) => {
      this.status = this.getMap(response.data);
    });

    UserService.whoAmI()
      .then((response) => (this.user = response.data))
      .catch((error) => {
        console.log("Whoami: error");
        console.log(error);
        this.$store.dispatch("auth/logout");
        this.$router.push("/login/translator");
      });
  },

  methods: {
    getPending(orderBy, asc) {
      
      if(!orderBy && !asc)
        this.axios
          .get(process.env.VUE_APP_ROOT + "/documents/reviewer/pending.json", {
            headers: authHeader(),
          })
          .then((response) => (this.pending = response.data));
        else{
          const myData = new FormData();
          if(orderBy)
            myData.append("orderBy", orderBy);
          if(asc)
            myData.append("asc", asc);
          
          this.axios({
            method: "post",
            url: process.env.VUE_APP_ROOT + "/documents/reviewer/pending.json",
            data: myData,
            headers: authHeader(),
          }).then((response) => (this.pending = response.data));
        }
    },
    getCompleted(orderBy, asc) {
      if(!orderBy && !asc)
        this.axios
          .get(process.env.VUE_APP_ROOT + "/documents/reviewer/complete.json", {
            headers: authHeader(),
          })
          //.then((response) => (this.completed = response.data));
          .then(response => {
            this.completed = response.data;
          });
      else{
          const myData = new FormData();
          if(orderBy)
            myData.append("orderBy", orderBy);
          if(asc)
            myData.append("asc", asc);

          this.axios({
            method: "post",
            url: process.env.VUE_APP_ROOT + "/documents/reviewer/complete.json",
            data: myData,
            headers: authHeader(),
          }).then((response) => (this.completed = response.data));
      }
    },
    getRequest() {
      this.axios
        .get(process.env.VUE_APP_ROOT + "/documents/reviewer/request.json", {
          headers: authHeader(),
        })
        .then((response) => {
          this.request = response.data;
        });
    },
    sendDocId(id) {
      this.docId = id;
    },
    handleOk() {
      this.axios
        .get(process.env.VUE_APP_ROOT + "/documents/takeCharge/" + this.docId, {
          headers: authHeader(),
        })
        .then(() => {
          this.getRequest();
          this.getPending();
        })
        .catch(function (error) {
          console.log("TakeCharge: error");
          console.log(error);
        });
    },
    showNote(note) {
      this.$bvModal.msgBoxOk(note, { title: "Note del Richiedente" });
    },
    uploadModal(id) {
      this.docId = id;
      this.$bvModal.show("modal-upload");
    },
    audioModal(id) {
      this.docId = id;
      this.$bvModal.show("modal-audio");
    },
    handleUpload() {
      this.loading = true;
      UserService.uploadDoc(this.docId, this.file)
        .then(() => {
          this.getCompleted();
          this.getPending();
          this.loading = false;
          this.$bvToast.toast(`Revisione caricata con successo.`, {
            title: `Upload`,
            autoHideDelay: 4000,
            solid: true,
            variant:'success',
            appendToast: false
            })
        })
        .catch(function (error) {
          console.log("Upload: error");
          console.log(error);
          this.loading = false;
        });
    },
    handleAudioUpload() {
      this.loading = true;
      const myData = new FormData();
      myData.append("reviewed", this.audioBlob, "audio.mp3");

      this.axios({
        method: "post",
        url: process.env.VUE_APP_ROOT + "/documents/uploadRevision/" + this.docId,
        data: myData,
        headers: authFileHeader(),
      })
        .then((resp) => {
          console.log({ status: "success", response: resp });
          this.getCompleted();
          this.getPending();
          this.loading = false;
        })
        .catch((error) => {
          console.log({ status: "fail", response: error });
          this.loading = false;
        });
    },
    onRecord(msg) {
      this.audioBlob = msg;
    },
    log(msg) {
      console.log(msg);
    },
    order(type,msg) {
      if(msg){
        if(type == 'pending')
          this.getPending(this.orderBy, this.asc);
        else if(type == 'completed')
          this.getCompleted(this.orderBy, this.asc);
      } else {

        if(type == 'pending')
          this.getPending();
        else if(type == 'completed')
          this.getCompleted();

        this.orderBy = null;
        this.asc = 'ASC';
      }
      this.$refs.dropdown.hide(true);
      this.$refs.dropdown2.hide(true);
    }
  },
  computed: {
    audioBlobUrl: function () {
      if (this.audioBlob != null) {
        return URL.createObjectURL(this.audioBlob);
      }
      return null;
    },
  },
};
</script>
<style>
.jumbotron {
  background-image: url("/img/bg-tra.png");
}
.mask.tra {
  background-color: #0e82ae;
}
.butFile {
  border-radius: 0 25px 25px 0 !important;
  margin-left: -15px;
  z-index: 0;
  margin-bottom: 2px;
  height: 38px;
}
.btn-outline-primary,
.btn-outline-danger {
  z-index: 1;
}
.border-danger,
.btn-outline-secondary,
.btn-outline-primary,
.btn-outline-danger {
  border-width: 2px !important;
}

.middle {
  vertical-align: middle !important;
}
/* .table {display: grid;}  */
</style>
